import * as React from "react";

import {chain} from "@Common/utils/fs";

export const filteredOptions = (options) => chain(
    options,
    (_) => _.filter((option)=>option.unitprice > 0),
    (_) => _.map((option) => option.name),
    formatList,
);

export const formatList = (list) => {
    return list.map((item,index) =>
        index <= 0 ? (
            item
        ) : index + 1 < list.length ? (
            ", " + item
        ) : (
            " and " + item
        )
    ).join("");
};
